module.exports = __webpack_public_path__ + "static/contact-ba7a97dc3f4b9e2ec032e0374192c668.svg";